import { render, staticRenderFns } from "./BeContentServiceDetails.vue?vue&type=template&id=15167eb0&scoped=true"
import script from "./BeContentServiceDetails.vue?vue&type=script&lang=js"
export * from "./BeContentServiceDetails.vue?vue&type=script&lang=js"
import style0 from "./BeContentServiceDetails.vue?vue&type=style&index=0&id=15167eb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15167eb0",
  null
  
)

export default component.exports